/**
 * EncryptedContentPlaceholder - 加密收藏夹占位组件
 * 显示锁图标、标题、密码输入框和提交按钮
 */

import React, { useState } from 'react';
import { Input, Button } from 'antd';
import { VaultIcon } from '@phosphor-icons/react';

export interface EncryptedContentPlaceholderProps {
  /** 密码提交回调 */
  onPasswordSubmit: (password: string) => void;
  /** 是否正在验证 */
  loading?: boolean;
  /** 错误信息 */
  error?: string;
}

export const EncryptedContentPlaceholder: React.FC<EncryptedContentPlaceholderProps> = ({
  onPasswordSubmit,
  loading = false,
  error,
}) => {
  const [password, setPassword] = useState('');

  const handleSubmit = () => {
    if (password.trim()) {
      onPasswordSubmit(password.trim());
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && password.trim()) {
      handleSubmit();
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '80px 20px',
        minHeight: '40vh',
      }}
    >
      {/* 锁图标 */}
      <VaultIcon
        size={80}
        weight="fill"
        style={{ color: 'var(--ant-color-text-quaternary)', marginBottom: 24 }}
      />

      {/* 标题 */}
      <h3
        style={{
          fontSize: 18,
          fontWeight: 500,
          color: 'var(--ant-color-text)',
          marginBottom: 8,
        }}
      >
        该收藏夹已加密
      </h3>

      {/* 副标题 */}
      <p
        style={{
          fontSize: 14,
          color: 'var(--ant-color-text-secondary)',
          marginBottom: 24,
        }}
      >
        输入密码后方可浏览
      </p>

      {/* 密码输入框 */}
      <div style={{ width: 280, marginBottom: 16 }}>
        <Input.Password
          placeholder="请输入访问密码"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyPress={handleKeyPress}
          status={error ? 'error' : undefined}
          disabled={loading}
        />
        {error && (
          <div
            style={{
              fontSize: 12,
              color: 'var(--ant-color-error)',
              marginTop: 4,
            }}
          >
            {error}
          </div>
        )}
      </div>

      {/* 提交按钮 */}
      <Button
        type="primary"
        onClick={handleSubmit}
        loading={loading}
        disabled={!password.trim()}
        style={{ width: 280 }}
      >
        验证密码
      </Button>
    </div>
  );
};

export default EncryptedContentPlaceholder;
